import { ChangeDetectionStrategy, Component, computed, Input, signal } from '@angular/core';

@Component({
  selector: 'app-task-view-sidebar-wrapper',
  template: `
    <lib-sidebar-wrapper 
      label="Aufgabe" 
      [entityRoute]="entityRoute()">
      <app-task-view [showBreadcrumb]="false" />
    </lib-sidebar-wrapper>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TaskViewSidebarWrapperComponent {
  private readonly _taskId = signal<string>('');

  @Input()
  set taskId(value: string) {
    this._taskId.set(value);
  }

  readonly entityRoute = computed(() => ['tasks', 'task', this._taskId()]);
}
